import React from 'react'
import SealProductPage from './SealProductPage'
import PistonsealOne from "../asset/pistonseal/1.png"
import PistonsealTwo from "../asset/pistonseal/2.png"
import PistonsealThree from "../asset/pistonseal/3.png"
import PistonsealFour from "../asset/pistonseal/4.png"
import PistonsealFive from "../asset/pistonseal/5.png"

const PistonRodSeals = () => (
  <SealProductPage
    title='Piston Rod Seals'
    imageAlt='Piston rod seal'
    images={[PistonsealOne, PistonsealTwo, PistonsealThree, PistonsealFour, PistonsealFive]}
    description='At HARDCOATS, we manufacture two types of high-performance CGB dynamic seals: Positive Segment Seals and Zero Leakage Seals. The Positive Segment Seal is designed to allow minimal leakage, acting as a lubricant between the stationary and moving shafts to reduce friction. This seal provides effective performance where some leakage is tolerable, while still improving overall efficiency. In contrast, the Zero Leakage Seal is engineered for applications where absolutely no leakage is allowed, ensuring airtight sealing under extreme conditions. These seals are critical in the Fueling Machine Head of the nuclear sector, where they must withstand high pressures of up to 145 kg/cm² and endure a shaft oscillation of 3 meters in 30 seconds, all while maintaining superior sealing performance.'
  />
)

export default PistonRodSeals
